import { render } from "./VoteList.vue?vue&type=template&id=5fdfb3a0&scoped=true"
import script from "./VoteList.vue?vue&type=script&lang=js"
export * from "./VoteList.vue?vue&type=script&lang=js"

import "./VoteList.vue?vue&type=style&index=0&id=5fdfb3a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdfb3a0"]])

export default __exports__